"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ls: ()=>ls
});
const message = 'The page localStorage was full, click "OK" to clear the localStorage and refresh the page, do you want to continue?\n\u9875\u9762 localStorage \u5DF2\u6EE1\uFF0C\u70B9\u51FB"\u786E\u5B9A"\u5C06\u6E05\u7A7A localStorage \u5E76\u5237\u65B0\u9875\u9762\uFF0C\u662F\u5426\u7EE7\u7EED?';
function lsGet(key) {
    let defaultVal = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    try {
        const value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : defaultVal;
    } catch (err) {
        return defaultVal;
    }
}
function lsSet(key, val) {
    const StringifiedVal = JSON.stringify(val);
    try {
        return window.localStorage.setItem(key, StringifiedVal);
    } catch (err) {
        if ((null == err ? void 0 : err.name) === 'QuotaExceededError') {
            const result = window.confirm(message);
            if (result) {
                window.localStorage.clear();
                return window.location.reload();
            }
        }
        throw err;
    }
}
const ls = {
    get: lsGet,
    set: lsSet,
    remove (key) {
        return window.localStorage.removeItem(key);
    },
    clear () {
        return window.localStorage.clear();
    }
};
exports.ls = __webpack_exports__.ls;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ls"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
